<template>
  <div class="patentList contBox">
    <div class="bar-title">查询条件</div>
    <div>
      <div class="search-top">
        <el-form :inline="true" :model="searchData" ref="searchForm" class="demo-form-inline" :label-width="120"
          label-suffix=":">
          <el-form-item label="结算日期">
            <el-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-model="searchData.time" type="daterange"
              range-separator="-" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="收款员">
            <el-select v-model="searchData.doctor_id" placeholder="请选择" clearable>
              <el-option v-for="item in dictList.duty_doctor" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <div></div>
          <div class="searchBut">
            <el-button class="color-main" @click="resetForm" type="primary">
              <i class="fa fa-refresh"></i>重置
            </el-button>
            <el-button @click="getDataList" class="color-main" type="primary">
              <i class="fa fa-search"></i>查询
            </el-button>
            <!-- <el-button class="color-vice" type="primary" @click="exportTable">
              <i class="fa fa-arrow-down"></i>导出
            </el-button> -->
          </div>
        </el-form>
        
      </div>
    </div>
    <el-divider></el-divider>
    <div class="patientList">
      <div class="list-top flex-between">
        <div class="bar-title">月结明细</div>
        <div>
          <!-- <el-button class="color-yellow" v-print="print">
            <i class="fa fa-print"></i>
            打印全部
          </el-button> -->
          <!-- <el-button class="color-yellow" @click="printFile">
            <i class="fa fa-print"></i>
            打印文本
          </el-button> -->
          <!-- <el-button class="color-vice" @click="derive('consumable')">
            <i class="fa fa-file-text-o"></i>
            导出
          </el-button> -->
          <el-button class="color-vice" type="primary" @click="exportTable">
            <i class="fa fa-arrow-down"></i>导出
          </el-button>
        </div>
      </div>
      <!-- <vue-office-excel id="printArea1" :options="editorOptions" :src="excel" @rendered="rendered" /> -->
      <div class="table" id="printArea" ref="printView">
        <div class="patentList fatherHeight contBox">
          <div class="momey-total1">
            <div class="item1">日结时间范围:{{detail.time_frame}}</div>
            <div class="item">制表人:{{detail.tabulator?detail.tabulator:'无'}}</div>
            <div class="item">收款员:{{detail.payee?detail.payee:'无'}}</div>
            <div class="item2">制表时间:{{detail.tabulation_time}}</div>
          </div>
          <div class="momey-totals" >
            <div class="item1">起止发票号:{{detail.start_end_invoice}}</div>
            <div class="item">共计：{{detail.start_end_invoice_num?detail.start_end_invoice_num:0}}张</div>
          </div>
          <div class="momey-totals" >
            <div class="item1">作废发票号:{{detail.void_invoice}}</div>
            <div class="item">共计：{{detail.void_invoice_num?detail.void_invoice_num:0}}张</div>
          </div>
          <div class="momey-totals">
            <div class="item1">重打发票号:{{detail.reprint_invoice}}</div>
            <div class="item">共计：{{detail.reprint_invoice_num?detail.reprint_invoice_num:0}}张</div>
          </div>
          <div class="box-info">
            <el-descriptions title="月结信息" :column="4" border>
              <el-descriptions-item label="超声诊断费" label-class-name="my-label" content-class-name="my-content">{{info.cszd_fee?info.cszd_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="康复费" label-class-name="my-label" content-class-name="my-content">{{info.kf_fee?info.kf_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="病理诊断费" label-class-name="my-label" content-class-name="my-content">{{info.blzd_fee?info.blzd_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="放射诊断费" label-class-name="my-label" content-class-name="my-content">{{info.fszd_fee?info.fszd_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="核医学" label-class-name="my-label" content-class-name="my-content">{{info.hyx_fee?info.hyx_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="实验室诊断费" label-class-name="my-label" content-class-name="my-content">{{info.syszd_fee?info.syszd_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="影像诊断费" label-class-name="my-label" content-class-name="my-content">{{info.yxzd_fee?info.yxzd_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="手术治疗费" label-class-name="my-label" content-class-name="my-content">{{info.sszl_fee?info.sszl_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="材料费" label-class-name="my-label" content-class-name="my-content">{{info.cl_fee?info.cl_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="药剂费" label-class-name="my-label" content-class-name="my-content">{{info.yj_fee?info.yj_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="其他收入" label-class-name="my-label" content-class-name="my-content">{{info.other?info.other:0}}</el-descriptions-item>
              <el-descriptions-item label="透析-血液透析" label-class-name="my-label" content-class-name="my-content">{{info.tx_xytx_fee?info.tx_xytx_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="透析-血液透析滤过" label-class-name="my-label" content-class-name="my-content">{{info.tx_xytxlg_fee?info.tx_xytxlg_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="一般检查治疗费" label-class-name="my-label" content-class-name="my-content">{{info.ybjczl_fee?info.ybjczl_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="一般医疗服务费" label-class-name="my-label" content-class-name="my-content">{{info.ybylfw_fee?info.ybylfw_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="其他医疗服务" label-class-name="my-label" content-class-name="my-content">{{info.qtylfw_fee?info.qtylfw_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="一般类非手术治疗费" label-class-name="my-label" content-class-name="my-content">{{info.yblfss_fee?info.yblfss_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="中医治疗费" label-class-name="my-label" content-class-name="my-content">{{info.zyzl_fee?info.zyzl_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="社区卫生服务及预防保健项目" label-class-name="my-label" content-class-name="my-content">{{info.sqwsfw_fee?info.sqwsfw_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="自费总额（总）" label-class-name="my-label" content-class-name="my-content">{{info.total_psn_fee?info.total_psn_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="自费总额（现金）" label-class-name="my-label" content-class-name="my-content">{{info.total_cash_fee?info.total_cash_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="自费总额（医保个人账户）" label-class-name="my-label" content-class-name="my-content">{{info.total_mediCard_fee?info.total_mediCard_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="自费总额（微信）" label-class-name="my-label" content-class-name="my-content">{{info.total_wechat_fee?info.total_wechat_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="自费总额（支付宝）" label-class-name="my-label" content-class-name="my-content">{{info.total_ali_fee?info.total_ali_fee:0}}</el-descriptions-item>
              <el-descriptions-item label="自费总额（银行卡）" label-class-name="my-label" content-class-name="my-content">{{info.total_bank_fee?info.total_bank_fee:0}}</el-descriptions-item>
          </el-descriptions>
            <div class="momey-total">
              <div class="item">总金额:{{total.total?total.total:0}}</div>
              <div class="item">自费金额:{{total.psn_cash_pay?total.psn_cash_pay:0}}</div>
              <div class="item">账户支付:{{total.account_payment_fee?total.account_payment_fee:0}}</div>
              <div class="item">报销金额:{{total.fund_pay_sumamt?total.fund_pay_sumamt:0}}</div>
              <div class="item">优惠金额:{{total.discount_amount?total.discount_amount:0}}</div>
              <div class="item">医保舍入金额:{{total.medical_rounding_amount?total.medical_rounding_amount:0}}</div>
            </div>
            <div class="momey-total">
              <div class="item1">共计(大写):{{total.total_in_words?total.total_in_words:0}}</div>
              <div class="item">共计(小写):{{total.total_in_figures?total.total_in_figures:0}}</div>
              <div class="item">实收金额误差:{{total.amount_difference?total.amount_difference:0}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount,
    getCurrentInstance
  } from 'vue'
  import service from '@/utils/request'
  import { gitDictList, gitDictVal, TimestampToTime, downLoadXlsx } from '@/utils/tool'
  import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
  import viewDialog from '../registerList/viewDialog.vue'
    //引入VueOfficeExcel组件
    import VueOfficeExcel from '@vue-office/excel'
  //引入相关样式
  import '@vue-office/excel/lib/index.css'
  import comm from '@/utils/comm'
  export default {
    name: 'patentList',
    components: {
      viewDialog,
      VueOfficeExcel
    },
    setup() {
      const {proxy} = getCurrentInstance()
      const state = reactive({
        searchData: {
          time: '',
        },
        editorOptions: {
          toolbar: true,
          width: '600px',
          height: '400px'
        },
        searchForm: null,
        detail:'',
        info:'',
        total:'',
        excel:''
      })
      onMounted(() => {
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        getDataList()
        // getDataLists()
      })
      const getDataList = async () => {
        let data = {}
        if (state.searchData.time) {
          data = {
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1], 
          }
        } else {
          data = {
            start_time: '',
            end_time: '',
          }
        }
        let res = await service.post(
          'api/settle/getNewMonthSettle',
          data
        )
        if (res.code === 0) {
          state.detail = res.data.detail
          state.total = res.data.total
          state.info = res.data.info
        }
      }
      const getDataLists = async () => {
        let port = location.protocol
  let ip = comm.cesuUrl
  let requestUrl = `${port}//${ip}`
  console.log(requestUrl)
        let data = {}
        if (state.searchData.time) {
          data = {
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1], 
          }
        } else {
          data = {
            start_time: '',
            end_time: '',
          }
        }
        let res = await service.post(
          'api/export/getExportMonthSettleFile',
          data
        )
        if (res.code === 0) {
          console.log(res)
          state.excel =requestUrl + res.data.file_url
        }
      }
      const resetForm = ()=>{
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        getDataList()
      }
      const exportTable = (row) => {
        let data = {}
        if (state.searchData.time) {
          data = {
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1],
          }
        } else {
          data = {
            start_time: '',
            end_time: '',
          }
        }
        let time = TimestampToTime()
        let title = `月结明细${time}.xlsx`
        downLoadXlsx('/api/export/exportNewMonthSettle', data, title)
      }
      return {
        ...toRefs(state),
        getDataList,
        exportTable,
        getDataLists,
        resetForm
      }
    },
  }
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
  
</style>
<style scoped lang="scss">
  #printArea1{
    width: 100%;
    height: 800px;
  }
  ::v-deep .my-label {
    background-color: rgba(49, 102, 174, 0.1) !important;
    border: 1px solid #e4e9f8 !important;
    color:#3166ae !important;
    font-weight: 400 !important;
  }

  ::v-deep  .my-content {
    background: #FDE2E2;
  }
  .demo-form-inline {
    margin-top: 0;
    //flex: 1;
    display: grid;
    grid-template-columns: 35% 25% 25% 15%;
    grid-template-rows: repeat(1, 40px);
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .search-top .w-208 {
    width: 208px;
  }

  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 220px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    /* margin-top: 10px; */
    height: calc(100% - 10px );

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {
    width: 100%;
    display: flex;
    justify-content: end;
    margin-right: 28px;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .labelSet1 {
    width: 60px;
    height: 30px;
    line-height: 30px;
    display: block;
    text-align: center;
    color: #fff;
    border-radius: 5px;
  }

  .psckset {
    background-color: #409EFF;
  }

  .psckset1 {
    background-color: #a4cef8;
    color: #1581fc;
    border: 1px solid #1581fc;
  }

  .lcsyset {
    background-color: #c6f1b1;
    color: #3bb207;
    border: 1px solid #5bd324;
  }

  .lcsyset1 {
    background-color: #f1beb1;
    color: #f35c0c;
    border: 1px solid #f35c0c;
  }
  .info-table{
  width: 100%;
  margin: 10px 0;
  tr{
    height: 40px;
  }
  td{
    padding-left: 20px;
  }
  .color-blue{
    color:#3166ae;
    font-size: 14px;
    width: 230px;
  }
  .border-right{
    /* border-right: 1px solid gray; */
  }

}
.info-table tr:nth-child(2n+1){
  background-color:rgba(49, 102, 174, 0.1);
}
.momey-total{
  display: flex;
  /* margin: 10px; */
  margin-bottom: 10px;
  line-height: 30px;
  font-size: 14px;
  .item{
    margin-right: 20px;
    width: 150px;
    color:#444;
  }
  .item1{
    margin-right: 20px;
    color:#444;
  }
}
.momey-total1{
  display: flex;
  /* margin: 10px; */
  line-height: 30px;
  font-size: 14px;
  .item1{
    margin-right: 20px;
    width: 350px;
    color:#444;
  }
  .item{
    margin-right: 20px;
    width: 250px;
    color:#444;
  }
  .item2{
    margin-right: 20px;
    width: 250px;
    text-align: right;
    color:#444;
  }
}
.momey-totals{
  display: flex;
  /* margin: 10px; */
  line-height: 30px;
  font-size: 14px;
  .item1{
    text-align: left;
    margin-right: 20px;
    width: 100%;
    color:#444;
  }
  .item{
    text-align: right;
    margin-right: 20px;
    width: 150px;
    color:#444;
  }
}
</style>